import React from "react";
import Parallax2 from "../common/parallax/Parallax2";
import GallerySection1 from "./section1/GallerySection1";
import GallerySection2 from "./section2/GallerySection2";
import GalllerySection3 from "./section3/GalllerySection3";
import MediaGallerySection4 from "./section4/MediaGallerySection4";
import GalleryVideoSection5 from "./section5/GalleryVideoSection5";
import ClassGallerySection6 from "./section6/ClassGallerySection6";

const Gallery = () => {
  return (
    <>
      <Parallax2 heading="GALLERY" subHeading="OUR GALLERY" />
      <GallerySection2 />
      <GallerySection1 />

      <MediaGallerySection4 />
      {/* <GalleryVideoSection5 /> */}
      <GalllerySection3 />
      <ClassGallerySection6 />
    </>
  );
};

export default Gallery;
